export default __webpack_public_path__ + "static/media/application-screenshots-03.9b6cd6c7.jpg";